import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MedAmountTable from './MedAmountTable.js';
import EditMedAmountModal from './EditMedAmountModal.js';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb.js';
import paths from 'routes/paths.js';

const MedAmount = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [medamtval, setMedAmtVal] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleOpenAddModal = () => {
        setMedAmtVal(null);
        setEditTrigger(0);
        setShowModal(true);
    };

    const callAnotherChildMethod = () => {
        setTrigger((prev) => prev + 1);
    };

    const callAnotherEditChildMethod = (editValue) => {
        setMedAmtVal(editValue);
        setEditTrigger((prev) => prev + 1);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Med-Amount', href: paths.medAmount, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Amount</h5>
                        </Card.Header>
                        <Card.Body>
                            <MedAmountTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <EditMedAmountModal
                show={showModal}
                onHide={() => setShowModal(false)}
                medamtvalue={medamtval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default MedAmount;

